<template>
  <div justify="center">
    <v-dialog v-model="dialog" persistent  max-width="700px">      
      <v-card>                
        <v-card-title style="color: #00aeef; padding-bottom:5px">
          <h3>{{electronicDocumentsDocumentItem.typeDocument}}-{{electronicDocumentsDocumentItem.referenceId}}-{{electronicDocumentsDocumentItem.state}}-({{electronicDocumentsDocumentItem.documents.length}}) </h3>
        </v-card-title>
        <v-card-text style="vertical-align: top; padding-top:-5px">
            <v-data-table
              item-kek="uniqueId"
              flat              
              :items="electronicDocumentsDocumentItem.documents"
              :pagination.sync="pagination"
              :rows-per-page-items="pagination.rowsPerPageItems"
              :total-items="pagination.totalItems"
              :headers="headers"
              class="v-table-list theme--light"
              id="tableDialog"
            >              
              <template slot="items" scope="props">
                <tr>
                  <!-- <td class="text-xs-left 1%">
                      <v-icon color="accent" large outline 
                      >library_books</v-icon>                        
                  </td>                   -->
                  <td class="text-xs-left 1%">{{ props.item.description }}</td>                  
                  <td style="padding-left:1%" class="text-xs-left cut-text">
                    <v-btn icon small class="pa-1" title="Descargar Documento" @click="download(props.item.uniqueId)">
                      <v-avatar size="40">
                      <img src="/static/img/descargar.png" width="40" height="40" style="float: left;">
                      </v-avatar>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <div>{{$t('message.noElectronicDocuments')}}</div>
              </template> 
            </v-data-table>
        </v-card-text>
        <v-divider style="margin:0px"></v-divider>     
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" small text @click="dialog = false">Cerrar</v-btn>                    
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import { downloadPDF } from "@/common/helpers/helpers";

  export default {    
    computed: {       
        ...mapGetters([
        "electronicDocumentsDocumentItem"])
    },
    
    mounted() {
      console.log(this.electronicDocumentsDocumentItem)
    },

    data () {
      return {        
        dialog: false,
        pagination: {
          page: 1,
          rowsPerPage: 20,
          totalItems: 0,
          rowsPerPageItems: [20]
        },
        headers: [
          // {
          //     align: "left",
          //     width: "50px",
          //     sortable: false,
          //     text: "",
          //     value: ""
          // },
          {
              align: "left",
              sortable: false,
              text: "Listado de Documentos Firma Electrónica",
              value: "description",
              color: "#c0c0c0"              
          }            
      ],   
      }
    },

     methods: {

      openDialog(referenceId){        

        this.$store.dispatch("getDocuments", referenceId)
          .then(()=>{
            this.dialog=true;
          });
      },

      download(uniqueId){

        let document = this.electronicDocumentsDocumentItem
                          .documents.find(d=> d.uniqueId == uniqueId);        
        var binary_string = window.atob(document.bytes);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }        
        downloadPDF(bytes.buffer, document.description + ".pdf");
      }      
    }
  }
</script>
<style>
#tableDialog table.v-table thead tr th {
    color: #005CAE;
}
</style>